import{t as o}from"./index-65eacd9d.js";import"emotion";import{_ as t}from"./index-668926cd.js";export default function(r){return t(o(r))}
